module.exports = __webpack_public_path__ + "img/95C.873f131d.png";